<template>
  <div>
    <div class='row'>
      <div class='col-xs-12'>
        <select-box v-model="productionSourcesValue" :options='productionSources'
          :label="$t('prosumerDeclaration.installation.productionSource')" @input="selectProductionsource" required />
      </div>
      <div class='col-xs-12 col-md-6'>
        <number-box v-model='value.maxOutputPower' :max="20" :label="$t('prosumerDeclaration.installation.maxOutputPower')"
                    :placeholder="$t('prosumerDeclaration.installation.kva')" required
                    show-tooltip @tooltipClick='maxOutputPowerModalOpen = true' :note='maxOutputPowerNote' />
      </div>
      <div v-if="value.productionSource && value.productionSource.value === 'photovoltaic'" class='col-xs-12 col-md-6'>
        <number-box v-model='value.totalPower' :max="20" :label="$t('prosumerDeclaration.installation.totalPower')"
                    :placeholder="$t('prosumerDeclaration.installation.kwc')" required
                    show-tooltip @tooltipClick='totalPowerModalOpen = true' />
      </div>
      <div class='col-xs-12 lib__field'>
        <template v-for='(inverter, index) in value.powerInverters'>
          <label class='lib__field__label lib__no-padding'>
            {{ $t('prosumerDeclaration.installation.powerInverter') }} {{ index + 1 }}
            <span class='lib__tooltips' @click='powerInverterModalOpen = true'>
              <span>
                <i class='fas fa-info-circle lib__clickable-tooltips'></i>
              </span>
            </span>
          </label>
          <div class='row'>
            <div class='col-xs-6'>
              <text-box v-model='value.powerInverters[index].brand'
                        :placeholder="$t('prosumerDeclaration.installation.brand')"
                        required />
            </div>
            <div class='col-xs-5'>
              <text-box v-model='value.powerInverters[index].model'
                        :placeholder="$t('prosumerDeclaration.installation.model')"
                        required />
            </div>
            <div v-if='value.powerInverters.length > 1' class='col-xs-1'>
              <button class='lib__btn-action' type='button' @click.prevent='removeInverter(index)'>
              <span class='lib__badge lib__badge--primary'>
                <i class='fas fa-trash'></i>
              </span>
              </button>
            </div>
          </div>
        </template>
        <button v-if='value.powerInverters.length < 6' class='lib__btn-action' type='button' @click.prevent='addInverter'>
            <span class='lib__badge lib__badge--primary'>
              <i class='fas fa-plus'></i>
            </span>
          <span class='lib__btn-action__label'>{{ $t('prosumerDeclaration.installation.addInverter') }}</span>
        </button>
      </div>
    </div>

    <ModalDialog :closeable="$t('common.close')" :open.sync='totalPowerModalOpen'>
      <h3>{{ $t('prosumerDeclaration.installation.modal.totalPower.title') }}</h3>
      <p v-html="$t('prosumerDeclaration.installation.modal.totalPower.text')" />
    </ModalDialog>

    <ModalDialog :closeable="$t('common.close')" :open.sync='maxOutputPowerModalOpen'>
      <h3>{{ $t('prosumerDeclaration.installation.modal.maxOutputPower.title') }}</h3>
      <p v-html="$t('prosumerDeclaration.installation.modal.maxOutputPower.text')" />
    </ModalDialog>

    <ModalDialog :closeable="$t('common.close')" :open.sync='powerInverterModalOpen'>
      <h3>{{ $t('prosumerDeclaration.installation.modal.powerInverter.title') }}</h3>
      <p v-html="$t('prosumerDeclaration.installation.modal.powerInverter.text')" />
    </ModalDialog>
  </div>
</template>

<script lang='ts'>
import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import { ProductionSource, TechnicalInformation } from '@/models/prosumer-declaration/prosumer-declaration'

@Component({
  name: 'technical-information-component'
})
export default class TechnicalInformationComponent extends Vue {
  @Prop({ type: Object, required: true }) public readonly value!: TechnicalInformation
  public productionSources: ProductionSource[] = []
  public productionSourcesValue: string |undefined=''
  public totalPowerModalOpen: boolean = false
  public maxOutputPowerModalOpen: boolean = false
  public powerInverterModalOpen: boolean = false

  public mounted() {
    this.fetchProductionSources()
    this.productionSourcesValue= this.value.productionSource?.value
  }

  public async fetchProductionSources() {
    const response = await this.$api.get<string[]>('ProsumerDeclaration/electricity-production-sources')
    this.productionSources = response.data.map((s) => {
      return { text: this.$tc(`prosumerDeclaration.productionSources.${s}`), value: s }
    })
  }

  public addInverter() {
    this.value.powerInverters.push({ brand: null, model: null })
  }

  public selectProductionsource(source:string) {
    this.value.productionSource = this.productionSources.find(s=>s.value === source)!
  }

  public removeInverter(index: number) {
    this.value.powerInverters.splice(index, 1)
  }

  public createDefaultSource(text: string | null): ProductionSource | null {
    if (!text) {
      return null
    }

    return {
      text,
      value: text
    }
  }

  public get maxOutputPowerNote(): string | null {
    if (this.value && this.value.maxOutputPower && this.value.maxOutputPower > 5) {
      return this.$tc('prosumerDeclaration.installation.maxOutputPowerNote')
    }
    return null
  }

  @Watch('value.productionSource', { deep: true })
  public onProductionSourceChanged(newVal: ProductionSource) {
    if (!newVal || newVal.value !== 'photovoltaic') {
      this.value.totalPower = null
    }
  }
}
</script>
